"use strict";

var Metric = React.createClass({
  remove: function(){
    if(this.props.onRemove) {
      this.props.onRemove(this.props);
    }
  },
  render: function(){
    return (
      <span className="metricaTag" key={this.props.id}>
        {this.props.name} <strong>[{this.props.value}]</strong>
        {(this.props.removable)?<a href="javascript:void(0);" onClick={this.remove}></a>:null}
      </span>
    );
  }
});

module.exports = Metric;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/Metric/metric.jsx